import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import BidReviewsDetailsModal from "./BidReviewsDetailsModal";

export default class BidReviewsDetailsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };

        this.onShowModal = this.onShowModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);
    }

    onShowModal() {
        this.setState({showModal: true});
    }

    onCloseModal() {
        this.setState({showModal: false});
    }

    onButtonClick(e) {
        e.preventDefault();
        this.onShowModal();
    }

    render() {
        return (
            <span>
                <button className="btn btn-primary btn-xs"
                        title={window.__js_bid_reviews.reviewers_opinions}
                        onClick={this.onButtonClick}>
                    <i className="fa fa-fw fa-search"></i>
                </button>
                <BidReviewsDetailsModal
                    competitionId={this.props.competitionId}
                    bidId={this.props.bidId}
                    show={this.state.showModal}
                    onClose={this.onCloseModal}
                />
            </span>
        );
    }
}

const elements = document.getElementsByClassName('bid-reviews-details-component');

for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    const competitionId = element.getAttribute('data-competition-id');
    const bidId = element.getAttribute('data-bid-id');

    ReactDOM.render(
        <BidReviewsDetailsComponent
            competitionId={competitionId}
            bidId={bidId}
        />,
        element
    );
}
